import { useSubscription } from '@apollo/client';
import React from 'react';
import { SetterOrUpdater } from 'recoil';
import { mixpanelReset } from 'src/common/userTracking';
import { IUserAtom } from '../../../recoil/atoms/user';
import { IUserSettings } from '../../../recoil/selectors/permissionsSelector';
import { logoutAjax } from '../../../services/auth/logoutAjax';
import { EEventGroup, ELocation, TEvent } from '../../gqlQuery';
import { getOnCreateEventQuery } from '../graphql/subscriptions';

export function CreateSubscription(props: {
  userSettings: IUserSettings;
  setUserAtom: SetterOrUpdater<{} | IUserAtom>;
  // loginPut: ActionCreatorWithPayload<Partial<TLoginSettings>, string>;
  // loginSettings: Partial<TLoginSettings>;
  // accessTokenJson: IAccessTokenJson;
}) {
  if (!props.userSettings?.accessToken) {
    return <></>;
  }

  const handleLogout = async () => {
    // eslint-disable-next-line
    logoutAjax({ setUserAtom: props.setUserAtom }); // logout by pass no params
    mixpanelReset();
    localStorage.clear(); //clear local storage
  };

  // const dispatch = useDispatch();
  // use apollo client atom since subscription will not fire properly after page load
  // const [createEvent] = useCreateEventMutation();
  // notify other client that a login occurred to force logout of all other clients
  // React.useEffect(() => {
  //   Logger.trace({
  //     message: 'trace-useEffect:props.accessToken',
  //     callerName: 'CreateSubscription',
  //     userSettings: props.userSettings,
  //     accessToken: props.userSettings?.accessToken,
  //   });
  //   // use access-token from getter since apolloClient is sychronized with this state
  //   if (props.userSettings?.accessToken) {
  //     createEvent({
  //       auth: {
  //         apikey: props.userSettings.apikey,
  //       },
  //       event: {
  //         source: ELocation.Powercall,
  //         target: ELocation.Powercall,
  //         type: EEventType.Login,
  //         group: EEventGroup.Login,
  //         userId: props.userSettings.userid,
  //         businessId: props.userSettings.businessId,
  //         payload: props.userSettings.accessToken as string,
  //       },
  //     });
  //     // dispatch(replaceUserSettings(props.userSettings));
  //   }
  // }, [createEvent, props.userSettings?.accessToken]);

  // const subscribeLoginEvent: TEvent = {
  //   target: ELocation.Powercall,
  //   group: EEventGroup.Login,
  //   userId: props.userSettings?.userid,
  //   businessId: props.userSettings?.businessId,
  // };

  // // NOTE: does not disconnect from unmounted components if using React StrictMode
  // // @todo try/catch on subscription failure
  // useSubscription<
  //   {
  //     onCreateEvent: TEvent;
  //   },
  //   TEvent
  // >(getOnCreateEventQuery(subscribeLoginEvent), {
  //   onData: ({ data }) => {
  //     //   console.log('App.tsx: onSubscriptionLoginData', {
  //     //     ...data,
  //     //     data: {
  //     //       ...data,
  //     //       onCreateEvent: {
  //     //         ...data.data?.onCreateEvent,
  //     //         payload: {
  //     //           ...(data.data?.onCreateEvent.payload?.startsWith('{') &&
  //     //           data.data?.onCreateEvent.payload?.endsWith('}')
  //     //             ? JSON.parse(data.data?.onCreateEvent.payload)
  //     //             : ''),
  //     //         },
  //     //       },
  //     //     },
  //     //   });
  //   },
  //   variables: subscribeLoginEvent,
  // });
  const [graphqlReady, setGraphqlReady] = React.useState(false);
  React.useEffect(() => {
    // delay start of graphql based on heuristics
    setTimeout(() => setGraphqlReady(true), 1_000);
  }, []);

  // const [healthcheckMutation] = useHealthcheckMutation();
  // React.useEffect(() => {
  //   // call immediately
  //   if (props.userSettings?.businessId) {
  //     healthcheckMutation({
  //       userSettings: props.userSettings,
  //     });
  //   }
  //   const interval = setInterval(
  //     async () =>
  //       await healthcheckMutation({
  //         userSettings: props.userSettings,
  //       }),
  //     15_000
  //   );
  //   return () => clearInterval(interval);
  // }, [props.userSettings]);

  // all business events funnel through here
  const subscribeUserEvent: TEvent = {
    target: ELocation.Dash, // change to powercall if needed
    userId: props.userSettings.userid,
    businessId: props.userSettings.businessId,
  };
  useSubscription<
    {
      onCreateEvent: TEvent;
    },
    TEvent
  >(getOnCreateEventQuery(subscribeUserEvent), {
    onData: ({ data }) => {
      // const payload =
      //   data.data?.onCreateEvent?.payload?.startsWith('{') &&
      //   data.data?.onCreateEvent?.payload?.endsWith('}')
      //     ? JSON.parse(data.data?.onCreateEvent?.payload)
      //     : undefined;
      // if (!payload) return;
      //   console.log('App.tsx: onSubscriptionUserSettingsData', {
      //     ...data,
      //     data: {
      //       ...data.data,
      //       onCreateEvent: {
      //         ...data.data?.onCreateEvent,
      //         payload,
      //       },
      //     },
      //   });
    },
    variables: subscribeUserEvent,
    skip: !props.userSettings.businessId || !graphqlReady,
  });

  // all business events funnel through here
  const subscribeBusinessEvent: TEvent = {
    target: ELocation.Dash, // change to powercall if needed
    businessId: props.userSettings.businessId,
  };
  useSubscription<
    {
      onCreateEvent: TEvent;
    },
    TEvent
  >(getOnCreateEventQuery(subscribeBusinessEvent), {
    onData: ({ data }) => {
      switch (data.data?.onCreateEvent?.group) {
        case 'call': {
          const payload = JSON.parse(data.data?.onCreateEvent.payload ?? '{}');
          switch (payload?.message?.messageType) {
            case 'logoutUser':
              if (
                String(payload?.message?.users?.userid) ===
                String(props.userSettings.userid)
              ) {
                handleLogout();
              }
              break;
          }
        }
        //   console.log('App.tsx: onSubscriptionCallData', {
        //     ...data,
        //     data: {
        //       ...data.data,
        //       onCreateEvent: {
        //         ...data.data?.onCreateEvent,
        //         payload: {
        //           ...(data.data?.onCreateEvent.payload?.startsWith('{') &&
        //           data.data?.onCreateEvent.payload?.endsWith('}')
        //             ? JSON.parse(data.data?.onCreateEvent.payload)
        //             : ''),
        //         },
        //       },
        //     },
        //   });
      }
    },
    variables: subscribeBusinessEvent,
    skip: !props.userSettings.businessId || !graphqlReady,
  });

  const subscribeUserSettingsEvent: TEvent = {
    target: ELocation.Powercall,
    group: EEventGroup.UserSettings,
    userId: props.userSettings.userid,
    businessId: props.userSettings.businessId,
  };
  useSubscription<
    {
      onCreateEvent: TEvent;
    },
    TEvent
  >(getOnCreateEventQuery(subscribeUserSettingsEvent), {
    onData: ({ data }) => {
      const payload =
        data.data?.onCreateEvent?.payload?.startsWith('{') &&
        data.data?.onCreateEvent?.payload?.endsWith('}')
          ? JSON.parse(data.data?.onCreateEvent?.payload)
          : undefined;
      if (!payload) return;
      // console.log('App.tsx: onSubscriptionUserSettingsData', {
      //   ...data,
      //   data: {
      //     ...data.data,
      //     onCreateEvent: {
      //       ...data.data?.onCreateEvent,
      //       payload,
      //     },
      //   },
      // });
      if (payload?.message?.messageType === 'invalidateRefreshToken') {
        handleLogout();
      }
    },
    variables: subscribeUserSettingsEvent,
    skip: !props.userSettings.businessId,
  });

  // const businessSMSMessageEvent: TEvent = {
  //   target: ELocation.Powercall,
  //   businessId: props.userSettings?.businessId,
  //   group: EEventGroup.BusinessSms,
  // };

  // useSubscription<
  //   {
  //     onCreateEvent: TEvent;
  //   },
  //   TEvent
  // >(getOnCreateEventQuery(businessSMSMessageEvent), {
  //   onData: ({ data }) => {
  //     //   console.log('App.tsx businessSMSSubscriptionData: ', data);
  //   },
  //   variables: businessSMSMessageEvent,
  // });

  // // subscribe to business group events (ie dashboard account updates)
  // const subscribeBusinessEvent: TEvent = {
  //   target: ELocation.Powercall,
  //   businessId: props.userSettings?.businessId,
  //   group: EEventGroup.BusinessSettings,
  //   type: EEventType.UpdateBusinessSettings,
  // };

  // useSubscription<
  //   {
  //     onCreateEvent: TEvent;
  //   },
  //   TEvent
  // >(getOnCreateEventQuery(subscribeBusinessEvent), {
  //   onData: ({ data }) => {
  //     //   console.log('App.tsx: onSubscriptionBusinessData', {
  //     //     ...data,
  //     //     data: {
  //     //       ...data.data,
  //     //       onCreateEvent: {
  //     //         ...data.data?.onCreateEvent,
  //     //         payload: {
  //     //           ...(data.data?.onCreateEvent.payload?.startsWith('{') &&
  //     //           data.data?.onCreateEvent.payload?.endsWith('}')
  //     //             ? JSON.parse(data.data?.onCreateEvent.payload)
  //     //             : ''),
  //     //         },
  //     //       },
  //     //     },
  //     //   });
  //   },
  //   variables: subscribeBusinessEvent,
  // });

  return <></>;
}
